import React, { useEffect, useState } from 'react';
import { UsersIcon } from 'lucide-react';
const TOTAL = 200;
export function ScarcityBar() {
  const [left, setLeft] = useState(17);
  useEffect(() => {
    const id = window.setInterval(() => {
      setLeft(prev => prev > 4 ? prev - 1 : prev);
    }, 47000);
    return () => window.clearInterval(id);
  }, []);
  const taken = TOTAL - left;
  const percent = Math.round(taken / TOTAL * 100);
  return <div className="w-full rounded-2xl border border-gold/40 bg-navy-deep/60 p-4" data-id="element-220" data-mp="2b56xyrdpzrl5">
      <div className="flex items-center justify-between gap-3" data-id="element-221" data-mp="2g6wdaj7z6rf1">
        <p className="flex items-center gap-1.5 text-xs font-semibold text-white/80 sm:text-sm" data-id="element-222" data-mp="226bs5gel8jid">
          <UsersIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-223" data-mp="274vdpfp9rta7" />
          Cupos al precio promocional
        </p>
        <p className="text-xs font-bold text-gold-light sm:text-sm" data-id="element-224" data-mp="fqke6lv8hep">
          Quedan {left} de {TOTAL}
        </p>
      </div>
      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-white/15" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos ocupados al precio promocional" data-id="element-225" data-mp="5d9zt9uav088">
        <div className="h-full rounded-full bg-gold transition-all duration-700" style={{
        width: `${percent}%`
      }} data-id="element-226" data-mp="3dcy1iohg6x66" />
      </div>
      <p className="mt-2 text-[11px] leading-snug text-white/60 sm:text-xs" data-id="element-227" data-mp="38fxti811fkcf">
        {percent}% de los cupos promocionales ya fueron reclamados. Al agotarse, el precio vuelve a
        USD $197.
      </p>
    </div>;
}